import { useEffect, useState } from "react";
import { Spinner } from "@phosphor-icons/react";
import { api } from "@/lib/apiClient";

export function ProtectedConversationAvatar({ mediaId, className = "", testId, fallback }) {
    const [blobUrl, setBlobUrl] = useState(null);
    const [errored, setErrored] = useState(false);

    useEffect(() => {
        if (!mediaId) {
            setBlobUrl(null);
            setErrored(false);
            return undefined;
        }
        let active = true;
        let objectUrl = null;
        api.get(`/messages/attachments/${mediaId}`, { responseType: "blob" })
            .then((res) => {
                objectUrl = URL.createObjectURL(res.data);
                if (active) setBlobUrl(objectUrl);
            })
            .catch(() => {
                if (active) setErrored(true);
            });
        return () => {
            active = false;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [mediaId]);

    if (!mediaId || errored) return fallback || null;
    if (!blobUrl) {
        return <div className={`${className} grid place-items-center`} data-testid={`${testId}-loading`}><Spinner size={14} className="animate-spin" color="#D4AF37" /></div>;
    }
    return <img src={blobUrl} alt="Conversation avatar" className={className} data-testid={testId} />;
}